import { isWeakMap as isWeakMap$1 } from '../../predicate/isWeakMap.mjs';

function isWeakMap(value) {
    return isWeakMap$1(value);
}

export { isWeakMap };
